import type { DevScenario } from '@arya/shared/domain';

import { MARKET_PROJECTS_FAILURE_SCENARIO } from './market-projects-failure.handler';

export const MARKET_SCENARIOS: readonly DevScenario[] = [MARKET_PROJECTS_FAILURE_SCENARIO];
